import { SITE } from "../data";

export default function HeroSection() {
  return (
    <section id="home" className="relative w-full min-h-[560px] md:min-h-[720px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20festive%20competition%20stage%20with%20warm%20coral%20and%20golden%20spotlight%20beams%2C%20floating%20confetti%2C%20bold%20graphic%20geometric%20shapes%2C%20stylized%20theatrical%20backdrop%2C%20energetic%20party%20atmosphere%2C%20deep%20warm%20shadows%20for%20text%20contrast%2C%20editorial%20poster%20aesthetic%2C%20rich%20saturated%20warm%20tones%2C%20no%20text&width=1600&height=900&seq=hl-hero-01&orientation=landscape"
        alt="黑料大赛舞台灯光与彩带构成的抽象赛事背景"
        title="黑料大赛 · 自黑搞笑线上趣味赛事"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65" />

      <div className="relative z-10 w-full px-4 md:px-8 pt-24 pb-16 md:pt-32 md:pb-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/25 text-background-50 text-xs md:text-sm animate-fade-up">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400" />
            {SITE.season} · 报名通道开放中
          </span>

          <h1 className="mt-5 font-heading text-4xl md:text-6xl font-black leading-[1.1] text-background-50 animate-fade-up">
            黑料大赛
            <span className="block mt-3 text-2xl md:text-4xl text-accent-400">
              自黑无敌，笑到最后
            </span>
          </h1>

          <p className="mt-6 text-sm md:text-lg text-background-100 leading-relaxed max-w-2xl animate-fade-up">
            一场只针对你自己的线上趣味赛事。赛制规则、参赛条件、评选标准与玩法介绍，
            在这里一次性讲清楚——从报名门槛到打分维度，不绕弯子。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 animate-fade-up">
            <a
              href="#play"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium whitespace-nowrap transition-colors"
            >
              <i className="ri-play-circle-line text-lg" aria-hidden="true"></i>
              查看玩法流程
            </a>
            <a
              href="#rules"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 text-sm md:text-base font-medium whitespace-nowrap transition-colors"
            >
              <i className="ri-file-list-3-line text-lg" aria-hidden="true"></i>
              赛制规则说明
            </a>
          </div>

          <ul className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs md:text-sm text-background-200">
            <li className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true"></i>5 条独立赛道
            </li>
            <li className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true"></i>全程免费报名
            </li>
            <li className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true"></i>只黑自己，不黑别人
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}